import React from 'react';
import { KeyRound, TrendingUp, UsersRound } from 'lucide-react';
import { motion } from 'framer-motion';

function TrustlessCard() {
    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.5 }
        }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    return (
        <div className="px-4 md:px-8 py-16 bg-white">
            <div className="max-w-7xl mx-auto">
                <motion.div 
                    className="text-center mb-12"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                >
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4 leading-tight">
                        Key Features of CelystikHub
                    </h2>
                    <div className="h-1 w-20 bg-indigo-600 mx-auto rounded-full"></div>
                    <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-lg">
                        Our platform creates a transparent ecosystem where innovation thrives through collaboration and aligned incentives
                    </p>
                </motion.div>

                <motion.div 
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {/* Card 1 */}
                    <motion.div 
                        className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-md p-6 hover:shadow-lg hover:border-indigo-200 transition-all duration-300"
                        variants={cardVariants}
                        whileHover={{ y: -10, transition: { duration: 0.2 } }}
                    >
                        <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-md mb-6">
                            <KeyRound size={28} className="text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-4">
                            Ownership Tokenization with Innovation Units (IUs)
                        </h3>
                        <p className="text-gray-600">
                            Tokenize project ownership. Contributors, creators, and investors hold fractional Innovation Units representing real economic rights in project success.
                        </p>
                    </motion.div>

                    {/* Card 2 */}
                    <motion.div 
                        className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-md p-6 hover:shadow-lg hover:border-indigo-200 transition-all duration-300"
                        variants={cardVariants}
                        whileHover={{ y: -10, transition: { duration: 0.2 } }}
                    >
                        <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center shadow-md mb-6">
                            <TrendingUp size={28} className="text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-4">
                            Proof of Impact (POI) Incentive Mechanism
                        </h3>
                        <p className="text-gray-600">
                            Tokenized incentives driven by community trust (staking) and measurable impact, making innovation scalable and sustainably rewarding.
                        </p>
                    </motion.div>

                    {/* Card 3 */}
                    <motion.div 
                        className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-md p-6 hover:shadow-lg hover:border-indigo-200 transition-all duration-300"
                        variants={cardVariants}
                        whileHover={{ y: -10, transition: { duration: 0.2 } }}
                    >
                        <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md mb-6">
                            <UsersRound size={28} className="text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-4">
                            Trustless Collaboration Ecosystem
                        </h3>
                        <p className="text-gray-600">
                            Projects grow through structured and transparent task-based collaboration. Contributors earn IUs by completing milestones. Creators assign tasks, track progress, and collaborate openly across global talent networks.
                        </p>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
}

export default TrustlessCard;
